<script>
	import Header from "../components/Header.svelte";
	import Button from '@smui/button/styled'; 
	import Textfield from '@smui/textfield/styled';
	import HelperText from '@smui/textfield/helper-text/index';
	import { api_host, price_settings_store } from "../stores.js";
	import { doFetch, getToken } from '../utils/Fetching.js';
	import * as yup from 'yup';
	import { toast_message } from '../utils/toast_message.js';


	const { auth_type, auth_token, domain_code } = getToken();

	let disable_send = false;
	let price_settings = {};

	price_settings_store.subscribe(value => {
		price_settings = value;
	});

	const formSchema = yup.object().shape({
		// full_name: yup
		// 	.string()
		// 	.required('Your Name is Required'),
		// email: yup
		// 	.string()
		// 	.required('Your Email is Required')
		// 	.email('Invalid email'),
		recipient_full_name: yup
			.string()
			.required('Recipient Name is Required'),
		recipient_email: yup
			.string()
			.required('Recipient Email is Required')
			.email('Invalid email'),
	});    

	let field_data = {};
	for (let nk in formSchema.describe().fields){
		field_data[nk] = "";
		field_data[`${nk}_iv`] = false;
		field_data[`${nk}_h`] = "";
	}

	function resetFieldData() {
		for (let nk in formSchema.describe().fields){
			field_data[`${nk}_iv`] = false;
			field_data[`${nk}_h`] = "";
		}
	}

	async function validateForm(){
		resetFieldData();
		let res = true;
		for (let nk in formSchema.describe().fields){
			await formSchema.validateAt(nk, field_data, {
				abortEarly: true  
			}).catch((err) => {
				field_data[`${nk}_iv`] = true;
				field_data[`${nk}_h`] = err.errors[0];
				res = false;
			});
		}
		return res;
	}

	async function validateSingle(nk) {
		const validateAtRes = await formSchema.validateAt(nk, field_data, {
			abortEarly: true  
		}).then(() => {
			field_data[`${nk}_iv`] = false;
			field_data[`${nk}_h`] = '';
		}).catch((err) => {
			field_data[`${nk}_iv`] = true;
			field_data[`${nk}_h`] = err.errors[0];
		});
	}

	async function send_referral() {
		if(await validateForm()){
			disable_send = true;
			const payload = {
				// name: field_data.full_name,
				// email: field_data.email,
				recipient_name: field_data.recipient_full_name,
				recipient_email: field_data.recipient_email
			};
			console.log(payload);

			const res = await doFetch(
				`${api_host}/api/referral/create`,
				'POST',
				payload,
				{ Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
			);
			disable_send = false;
			if (res.status) {
				toast_message(true, res.msg, 3000);
				field_data = {
					// full_name: '',
					// email: '',
					recipient_full_name: '',
					recipient_email: ''
				};
				resetFieldData();
			} else {
				toast_message(false, res.msg || 'Failed sending referral', 3000);
			}
		} else {
			toast_message(false, 'Please fill out all required fields', 3000);
		}
	}
</script>


<Header />

<div class="formholder">
	<div class="pagetitle">
		Referral Program
		<p style='font-size: 18px;font-weight: 400;'>Refer your friends/families so they receive {price_settings.referral_discount || 'X'}% discount when they book a yard, lawn service within {price_settings.referral_duration || 'X'} days.</p>
	</div>

	<!-- <div class="ff fullname">
		<Textfield
			required
			style="width: 100%;"
			helperLine$style="width: 100%;"
			variant="outlined"
			invalid={field_data.full_name_iv}
			bind:value={field_data.full_name}
			on:input={() => {validateSingle('full_name')}}
			on:blur={() => {validateSingle('full_name')}}
			label="Full Name"
		>
			<HelperText validationMsg=true persistent=true slot="helper">{field_data.full_name_h}</HelperText>
		</Textfield>
	</div>

	<div class="ff email">
		<Textfield
			required
			type="email"
			style="width: 100%;"
			helperLine$style="width: 100%;"
			variant="outlined"
			invalid={field_data.email_iv}
			bind:value={field_data.email}
			label="Email"
			on:input={() => {validateSingle('email')}}
			on:blur={() => {validateSingle('email')}}
		>
			<HelperText validationMsg=true persistent=true slot="helper">{field_data.email_h}</HelperText>
		</Textfield>
	</div> -->

	<div class="ff recipient_fullname">
		<Textfield
			required
			style="width: 100%;"
			helperLine$style="width: 100%;"
			variant="outlined" 
			invalid={field_data.recipient_full_name_iv}
			label="Friend's/family's name"
			bind:value={field_data.recipient_full_name}
			on:input={() => {validateSingle('recipient_full_name')}}
			on:blur={() => {validateSingle('recipient_full_name')}}
		>
			<HelperText validationMsg=true persistent=true slot="helper">{field_data.recipient_full_name_h}</HelperText>
		</Textfield>
	</div>

	<div class="ff recipient_email">
		<Textfield
			required
			type="email"
			style="width: 100%;"
			helperLine$style="width: 100%;"
			variant="outlined" 
			invalid={field_data.recipient_email_iv}
			label="Friend's/family's email"
			bind:value={field_data.recipient_email}
			on:input={() => {validateSingle('recipient_email')}}
			on:blur={() => {validateSingle('recipient_email')}}
		>
			<HelperText validationMsg=true persistent=true slot="helper">{field_data.recipient_email_h}</HelperText>
		</Textfield>
	</div>

	<div class="ff buttonbar">
		<Button
			on:click={() => {send_referral();}}
			disabled={disable_send}
			variant="raised" 
			class="button-shaped-round"
		>
			Send Referral
		</Button>
	</div>
</div>

<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas: "pt pt"
													"pc pc"
													"fn em"
													"rn re"
													"bb . ";
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
			margin-left: auto;
			margin-right: auto;
			display: grid;
			grid-template-columns: 1fr;
			grid-template-areas: "pt"
														"pc"
														"fn"
														"em"
														"rn"
														"re"
														"bb";
		}
	}
	.pagetitle {
		grid-area: pt;
		border-bottom: solid 1px #E9E9EC;
		font-size: 3rem;
		font-weight: bold;
	}
	.recipient_fullname {
		grid-area: rn;
	}
	.recipient_email {
		grid-area: re;
	}
	.buttonbar {
		grid-area: bb;
	}
	.ff {
		padding: 10px;
	}
</style>